
//
// Module preventing double submission of forms.
//
rs.module("common/form-submission", [],

    function () {

        // A data attribute for denoting inputs we disable.  Avoiding using data-js so we don't have to 
        // worry about interfering or working with existing data-js values.
        const disabledForSubmit = 'data-disabled-for-submit';
        const submitTriggerData = 'submit-trigger';

        // Initialize the module
        function initialize() {

            // When a form is submitted, disable any enabled submit buttons so the form cannot be double-submitted
            $("body").on("submit", "form", function (e) {
                // disable all submit buttons for the forms
                $(this).find("[type=submit]").each(function (idx, element) {

                    var el = $(element);
                    if (!el.is(":disabled")) {
                        el.prop("disabled", true).attr(disabledForSubmit, "true")
                    }
                });

                // capture the button which triggered the submit so we can send its data as part of the form submission.  If the form
                // submission was triggered via jQuery on the form object, there will be no event or submitter button
                if (e.originalEvent != null) {
                    var trigger = e.originalEvent.submitter;
                    if (trigger && trigger.name && trigger.value) {
                        $(this).data(submitTriggerData, trigger);
                    }
                }
            });
            
            // manipulate form values when the form is submitted
            $("body").on("formdata", "form", function (event) {
                var form = event.target;

                // send the triggering input's data with the form, which won't happen automatically since we disabled the button
                var submitTrigger = $(form).data(submitTriggerData);
                if (submitTrigger) {
                    var formData = event.originalEvent.formData;
                    formData.append(submitTrigger.name, submitTrigger.value);
                }
            });
        }

        // Handler for when jquery-validation encounters a validation error.  This is hooked up in jquery.validation.js. 
        function onInvalidFormSubmit(event, validator) {
            var form = $(event.target);

            // re-enable what we disabled
            form.find(`[${disabledForSubmit}]`).prop("disabled", false).removeAttr(disabledForSubmit);

            // remove submitter detail from the form
            form.removeData(submitTriggerData);
        }

        var exports = {
            initialize: initialize,
            onInvalidFormSubmit: onInvalidFormSubmit
        };

        return exports;
    }
);
